import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import ContactModal from "./ContactModal.tsx";

function NarBar() {
  const [disorders, setDisorders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDisorders = async () => {
      try {
        const response = await fetch('/api/disorders');
        const data = await response.json();
        setDisorders(data);
      } catch (err) {
        setDisorders([]);
      } finally {
        setLoading(false);
      }
    };
    fetchDisorders();
  }, []);

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <>
      <style>{`
        /* Dropdown hover styles */
        @media (min-width: 992px) {
          .navbar-nav .dropdown:hover > .dropdown-menu {
            display: block;
            margin-top: 0;
          }
          .navbar-nav .dropdown > .dropdown-toggle:active {
            pointer-events: none;
          }
        }
      `}</style>

      <nav
        className="navbar navbar-expand-lg navbar-dark sticky-top"
        style={{
          backgroundColor: "#1A2940",
          borderBottom: "1px solid #1A2940",
          minHeight: "60px"
        }}
      >
        <div className="container-fluid px-3 px-lg-4">
        
        {/* Brand */}
        <a 
          className="navbar-brand fw-bold text-white" 
          href="/"
          style={{ fontSize: "clamp(1.2rem, 2.5vw, 1.5rem)" }}
        >
          MintDB
        </a>

        {/* Mobile hamburger button */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{ 
            outline: 'none',
            boxShadow: 'none'
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible navbar content */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            
            <li className="nav-item">
              <a 
                className="nav-link px-2 px-lg-3" 
                href="/" 
                style={{
                  color: "#D1E0F4", 
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Home
              </a>
            </li>

            

            

            {/* Disorders Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle px-2 px-lg-3"
                href="#"
                id="disorderDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ 
                  color: "#D1E0F4", 
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Disorders
              </a>
              <ul 
                className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start" 
                aria-labelledby="disorderDropdown"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  fontSize: "0.9rem"
                }}
              >
                {loading && (
                  <li>
                    <span className="dropdown-item text-muted">Loading...</span>
                  </li>
                )}
                {!loading && disorders.length === 0 && (
                  <li>
                    <span className="dropdown-item text-muted">No disorders found</span>
                  </li>
                )}
                {disorders.map((disorder) => (
                  <li key={disorder.name}>
                    <Link
                      className="dropdown-item"
                      to={`/disorders/${disorder.name.toLowerCase()}`}
                      style={{
                        fontSize: "clamp(0.8rem, 1.5vw, 0.9rem)",
                        padding: "0.5rem 1rem",
                        textTransform: "uppercase"
                      }}
                    >
                      {disorder.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {/* Analysis Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle px-2 px-lg-3"
                href="#"
                id="analysisDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  color: "#D1E0F4",
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Analysis
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start"
                aria-labelledby="analysisDropdown"
                style={{
                  fontSize: "0.9rem",
                  minWidth: "300px"
                }}
              >
                <li>
                  <Link
                    className="dropdown-item"
                    to="/analysis"
                    style={{
                      fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)",
                      padding: "0.6rem 1rem",
                      fontWeight: "700",
                      color: "#1A2940",
                      backgroundColor: "#f8f9fa"
                    }}
                  >
                    Main Analysis
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis#database-query"
                    style={{
                      fontSize: "clamp(0.75rem, 1.5vw, 0.8rem)",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      color: "#64748b"
                    }}
                  >
                    Database Query
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis#target-disorder-analysis"
                    style={{
                      fontSize: "clamp(0.75rem, 1.5vw, 0.8rem)",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      color: "#64748b"
                    }}
                  >
                    Target & Disorder Analysis
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis#drug-analysis"
                    style={{
                      fontSize: "clamp(0.75rem, 1.5vw, 0.8rem)",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      color: "#64748b"
                    }}
                  >
                    Drug Analysis
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    className="dropdown-item"
                    to="/binding-sites"
                    style={{
                      fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)",
                      padding: "0.6rem 1rem",
                      fontWeight: "700",
                      color: "#1A2940",
                      backgroundColor: "#f8f9fa"
                    }}
                  >
                    Binding Sites
                  </Link>
                </li> */}
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <h6 className="dropdown-header text-uppercase" style={{
                    fontSize: "0.75rem",
                    fontWeight: "700",
                    color: "#60a5fa",
                    letterSpacing: "0.05em"
                  }}>
                    Suggested AI Queries
                  </h6>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis?prompt=Show me all the unique targets&autorun=true"
                    style={{
                      fontSize: "0.85rem",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    Show all unique targets
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis?prompt=List all disorders&autorun=true"
                    style={{
                      fontSize: "0.85rem",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    List all disorders
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis?prompt=Show all drugs&autorun=true"
                    style={{
                      fontSize: "0.85rem",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    Show all drugs
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis?prompt=Show targets for ADHD&autorun=true"
                    style={{
                      fontSize: "0.85rem",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    Show ADHD targets
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item ps-4"
                    to="/analysis?prompt=Show me all gene names&autorun=true"
                    style={{
                      fontSize: "0.85rem",
                      padding: "0.4rem 1rem 0.4rem 2rem",
                      whiteSpace: "normal",
                      wordWrap: "break-word"
                    }}
                  >
                    Show all gene names
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a
                className="nav-link px-2 px-lg-3"
                href="/sources"
                style={{
                  color: "#D1E0F4",
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Sources
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link px-2 px-lg-3"
                href="/team"
                style={{
                  color: "#D1E0F4",
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Team
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link px-2 px-lg-3"
                href="/faq"
                style={{
                  color: "#D1E0F4",
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                FAQ
              </a>
            </li>

            {/* Resources Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle px-2 px-lg-3"
                href="#"
                id="resourcesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  color: "#D1E0F4",
                  fontSize: "clamp(0.9rem, 1.8vw, 1rem)"
                }}
              >
                Resources
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start"
                aria-labelledby="resourcesDropdown"
                style={{
                  fontSize: "0.9rem",
                  minWidth: "200px"
                }}
              >
                <li>
                  <Link
                    className="dropdown-item"
                    to="/sql-guide"
                    style={{
                      fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)",
                      padding: "0.6rem 1rem"
                    }}
                  >
                    SQL Guide
                  </Link>
                </li>
              </ul>
            </li>

          </ul>

          {/* Auth buttons */}
          <div className="d-flex align-items-center mt-3 mt-lg-0 ms-lg-3 gap-3">
            {/* Contact Icon */}
            <button
              onClick={() => setIsContactModalOpen(true)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#D1E0F4',
                cursor: 'pointer',
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'color 0.2s ease',
                fontSize: '1.25rem'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#ffffff'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#D1E0F4'}
              title="Contact Us"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"/>
              </svg>
            </button>

            {user ? (
              <div className="d-flex align-items-center gap-2">
                <span className="text-white-50 me-2 d-none d-lg-inline" style={{ fontSize: "0.9rem" }}>
                  {user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="btn btn-outline-light btn-sm"
                  style={{ fontSize: "0.9rem" }}
                >
                  Logout
                </button>
              </div>
            ) : (
              <div className="d-flex gap-2">
                <Link to="/login">
                  <button className="btn btn-outline-light btn-sm" style={{ fontSize: "0.9rem" }}>
                    Login
                  </button>
                </Link>
                <Link to="/register">
                  <button className="btn btn-light btn-sm" style={{ fontSize: "0.9rem" }}>
                    Sign Up
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>

    {/* Contact Modal */}
    <ContactModal
      isOpen={isContactModalOpen}
      onClose={() => setIsContactModalOpen(false)}
    />
    </>
  );
}

export default NarBar;